export default __webpack_public_path__ + "static/media/washingMashin.9ac679e3.svg";